import axios from "axios";
import Cookies from "js-cookie";
import { API_URL } from "./utils/setApiUrl";

// Create axios instance with custom configuration
const instance = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-type": "application/json",
    },
    // Disable SSL certificate validation in development environments
    // This should only be used for development/testing, not in production
    httpsAgent: new (require("https").Agent)({
        rejectUnauthorized: false,
    }),
});

// Add response interceptor to handle session expiration
instance.interceptors.response.use(
  (response) => {
    // If response is successful, just return it
    return response;
  },
  (error) => {
    // Check if error is due to authentication failure (401 or 403)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Clear all authentication tokens and session data
      Cookies.remove("Biodit");
      Cookies.remove("loc");
      localStorage.removeItem("loc");
      localStorage.removeItem("session");
      localStorage.removeItem("level");

      // Remove auth header
      delete axios.defaults.headers.common["Authorization"];

      // Stop token expiration checker
      import("./utils/tokenExpirationChecker").then((module) => {
        module.default.stop();
      });

      // Redirect to login page
      window.location.href = "/login";
    }

    // Return the error for further handling if needed
    return Promise.reject(error);
  }
);

export default instance;
